import { dataGridRowHeight } from "@shared/components/DataGrid/constants";

interface UseVirtualizedDataGridHeightArgs {
  totalRows: number;
  headerHeight: number;
  horizontalScrollbarHeight: number;
  maxHeight?: number;
  /**
   * Optional override for the per-row height used in height calculations.
   * If not provided, falls back to the shared dataGridRowHeight constant.
   */
  rowHeight?: number;
}

interface UseVirtualizedDataGridHeightResult {
  bodyHeight: string | number;
  height: number;
}

const useVirtualizedDataGridHeight = ({
  totalRows,
  headerHeight,
  maxHeight,
  horizontalScrollbarHeight,
  rowHeight,
}: UseVirtualizedDataGridHeightArgs): UseVirtualizedDataGridHeightResult => {
  const effectiveRowHeight = rowHeight ?? dataGridRowHeight;
  const rowsHeight = totalRows * effectiveRowHeight + horizontalScrollbarHeight;
  const tableHeight = rowsHeight + headerHeight;

  const rowsFitMaxHeight = Number(maxHeight) > tableHeight;

  const bodyHeight = rowsFitMaxHeight ? rowsHeight : `calc(100% - ${headerHeight}px)`;

  return {
    bodyHeight,
    height: rowsFitMaxHeight ? tableHeight : Number(maxHeight),
  };
};

export default useVirtualizedDataGridHeight;
